import React from "react";
import InputGroup from "react-bootstrap/InputGroup";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import {UnitsContext} from "../../index";

export function Units() {
    return (
        <UnitsContext.Consumer>
            {({units, toggleUnits}) => (
                <>
                    <label>Units:</label>
                    <InputGroup>
                        <ToggleButtonGroup type="radio" name="options" value={units} onChange={toggleUnits}>
                            <ToggleButton value="metric">Metric</ToggleButton>
                            <ToggleButton value="imperial">Imperial</ToggleButton>
                        </ToggleButtonGroup>
                    </InputGroup>
                </>
            )}
        </UnitsContext.Consumer>
    );
}